module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDialog),
      expression: "isShowDialog"
    }]
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v(_vm._s(_vm.dialogContent))]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e4e4b736!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeDialog.vue
// module id = 199
// module chunks = 2